<template>
  <div class="edit-record">
    <a-table
      class="documentTable"
      id="documentTable"
      bordered
      :pagination="pagination"
      :columns="table.columns"
      :rowKey="record => record.id"
      :dataSource="table.data"
      :loading="table.loading"
      @change="handleTableChange">
    </a-table>
  </div>
</template>

<script>
import { getEditRecord, getEquipmentDocument } from '@/api/equipmentLedger'
export default {
  name: 'documentInfo',
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        if (model) {
          this.model = model
          this.initTableData()
        }
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      table: {
        data: [],
        columns: [
          {
            title: '序号',
            customRender: (text, record, index) => {
              return index + 1
            },
            width: 80
          },
          {
            title: '字段名称',
            dataIndex: 'label'
          },
          {
            title: '修改前值',
            dataIndex: 'previous'
          },
          {
            title: '修改后值',
            dataIndex: 'later'
          },
          {
            title: '修改人',
            dataIndex: 'updateName',
            width: 200
          },
          {
            title: '修改时间',
            dataIndex: 'updateTime'
          }
        ],
        loading: false
      },
      model: {},
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      },
      searchModel: {}
    }
  },
  methods: {
    initTableData () {
      const params = {
        equipmentId: this.model.id,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        paging: true
      }
      getEditRecord(params).then(res => {
        if (res.status === 0) {
          this.table.data = res.data.list
          this.pagination.total = res.data.total
        }
      })
    },
    handleTableChange (pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.initTableData()
    }
  }
}
</script>

<style lang="less" scoped>
.edit-record{
  >.documentTable  {
    margin-left: -1px;
    margin-right: -1px;
    .ant-table-pagination.ant-pagination {
      margin: 10px;
    }
  }
}
</style>